<div class="inline-input-group {{isEditing ? 'editing' : ''}}" (click)="enableEdit()">
    <input class="form-control" [(ngModel)]="tempLabel" (blur)="cancel($event);">
    <i *ngIf="isEditing" class="btn p-2 fad fa-circle-check text-success btn-validate" (click)="save($event);"></i>
    <i *ngIf="isEditing" class="btn p-2 fad fa-circle-xmark text-secondary btn-cancel" (click)="cancel($event);"></i>
    <i *ngIf="!isEditing" class="btn p-2 fad fa-pencil text-secondary btn-edit"></i>
</div>
